<template>
    <div class="mingcai">
        <swiperList :swiperStyle="{padding: '2.28rem 0 0 .4rem'}" :setSwiperNumFlag="true">
            <div class="slide"
            v-for="(item,index) in list1"
            :key="index"
            >
                <h2>{{ item.title }}</h2>
                <div :class="['slideBox swiper-container','slideBox' + index]">
                    <ul class="swiper-wrapper">
                        <li class="swiper-slide"
                        v-for="(value,ind) in item.list"
                        :key="ind"
                        @click="sildeClick(value)"
                        >
                            <div>
                                <h3 :class="[{h3: value.title.length > 5},{h31: value.title.length > 6}]" v-html="value.title"></h3>
                                <div class="list">
                                    <span v-html="value.keywords"></span>
                                </div>
                            </div>
                            <img :src="value.thumb" class="img">
                        </li>
                    </ul>
                </div>
            </div>
        </swiperList>
        <div class="cover" :style="{zIndex: coverFlag? '10': '-1'}">
            <!-- <div class="content">
                <img :src="item.thumb">
                <h2 v-html="item.title.replace(/<br \/>/g,'')">}</h2>
                <div class="xian"></div>
                <div class="list">
                    <span v-html="item.keywords"></span>
                </div>
                
            </div> -->
            
            <div class="swiper-container contentSwiper">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide"
                    v-for="(item,index) in list2"
                    :key="index"
                    >
                        <div class="content">
                            <img :src="item.thumb">
                            <h2 v-html="item.title.replace(/<br \/>/g,'')">}</h2>
                            <div class="xian">
                                <img src="@/assets/img/secondLevelPage/cradBottom.png">
                            </div>
                            <div class="list">
                                <span v-html="item.keywords"></span>
                            </div>
                            <div class="colse" @click="colseClick">
                                ×
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            list1: [                
                {
                    id:4,
                    title: "三十名菜",
                    list: [],
                },
                {
                    id:0,
                    title: "特色主食",
                    list: [],
                },
                {
                    id:1,
                    title: "京山特产",
                    list: []
                },
                {
                    id:2,
                    title: "蒸菜",
                    list: []
                },
                {
                    id:3,
                    title: "生态湖鲜",
                    list: []
                }
            ],
            item: {
                title: "",
            },
            coverFlag: false,
            list2: [],
            swiper: null,
        }
    },
    created(){
        // let title = 
        this.list.forEach((item,index) => {
            // console.log(item.keywords);
            let type = parseInt(item.type_options);
            let index2 = (type+1)%5;//新加的名菜，type是4，但是要排到第一个，所以使用此逻辑
            this.list1[index2].list.push(item);
        });


        this.list1.forEach((item,index) => {
            item.list.sort((a,b) => {
                return a.food_id - b.food_id;
            })
        });
        this.list1.forEach(item=> {
            this.list2.push(...item.list);
        });
        // console.log(this.list2);
    },
    methods: {
        colseClick(){
            this.coverFlag = false;
        },
        sildeClick(item){
            this.item = item;
            this.coverFlag = true;
            let index = 0;
            for(let i = 0; i < this.list2.length; i++){
                if(this.list2[i].title == item.title){
                    index = i;
                }
            }
            console.log(this.swiper);
            this.swiper.slideTo(index,300,false);
            // this.$emit("sildeClick",item)
        }
    },
    mounted(){
        let _this = this;
        for(let i = 0; i < 5; i++){
            let swiper = new Swiper('.slideBox' + i, {
                slidesPerView: "auto",
                // initialSlide: _this.levelThreeIndex,
            });
        }
		setTimeout(() => {
            this.swiper = new Swiper('.contentSwiper',{});
            // console.log(this.swiper);
        },200)
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    },
    props: {
        list: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
.mingcai{
    .slide{
        margin-bottom: .62rem;
        h2{
            font-size: .4rem;
            color: #333;
            font-weight: bold;
            margin-bottom: .3rem;
        }
        .slideBox{
            width: 100%;
            height: 3.3rem;
            .swiper-wrapper{
                display: flex;
                align-items: center;
                >li{
                    width: 2.16rem;
                    height: 3.12rem;
                    background: #fff;
                    box-shadow:0px .12rem .22rem 0px rgba(68,52,14,0.1);
                    border-radius: .1rem;
                    margin-right: .54rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding-top: .3rem;
                    padding-left: .14rem;
                    h3{
                        color: #333;
                        font-size: .36rem;
                        line-height: .42rem;
                        font-family: "siyuan";
                        font-weight: bold;
                        // &.h3{
                        //     font-size: .3rem;
                        // }
                        // &.h31{
                        //     font-size: .28rem;
                        // }
                    }
                    .list{
                        display: flex;
                        align-items: center;
                        margin-top: .14rem;
                        span{
                            padding: 0 .1rem;
                            height: .34rem;
                            border-radius: .17rem;
                            font-size: .2rem;
                            background:rgba(107,214,195,.2);
                            color: #4EC0AC;
                            line-height: .34rem;
                        }
                    }
                    .img{
                        width: 2.5rem;
                        height: 1.6rem;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }
                }
            }
        }
    }
    .cover{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        overflow: hidden;
        background: rgba(0,0,0,.5);
        z-index: -1;
        .contentSwiper{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            // transform: translate(-50%,-50%);
            // overflow: initial;
            .colse{
                width: .72rem;
                height: .72rem;
                border: .04rem solid #eee;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -1.46rem;
                border-radius: 50%;
                color: #eee;
                font-size: .5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: .7;
            }
            li{
                width: 100%;
                height: 100%;
                position: relative;
                .content{
                    width: 6rem;
                    height: 8rem;
                    background: #fff;
                    border-radius: .1rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding-top: .78rem;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                        img{
                            width: 5.7rem;
                            height: 3.65rem;
                        }
                        h2{
                            font-size: .68rem;
                            color: #333;
                            font-family: "siyuan";
                            margin-top: .92rem;
                        }
                        .xian{
                           width: 2.14rem;
                           height: .08rem;
                           margin: .26rem 0.22rem;
                           img{
                               width: 100%;
                               height: 100%;
                           } 
                        }
                        .list{
                            display: flex;
                            span{
                                color: #999;
                                font-size: .36rem;
                            }
                        }
                    }
                }
                
        }
        .content{
            
        }
    }
}
</style>